import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-cancelled',
    standalone: true,
    imports: [],
    templateUrl: './cancelled.component.html',
    styleUrls: ['./cancelled.component.scss']
})
export class CancelledPageComponent {
    constructor(private router: Router) {}

    navigateToHome(): void {
        this.router.navigate(['/']);
    }
}
